const formatUrl = text => {
  // Split the URL into an array to distinguish double slashes from single slashes
  let formatted;

  const arr = Array.from(text);

  arr.forEach((el, i) => {
    if (
      el.textContent.includes('https://') ||
      el.textContent.includes('http://')
    ) {
      const doubleSlash = el.textContent.split('//');

      // Format the strings on either side of double slashes separately
      formatted = doubleSlash
        .map(
          str =>
            // Insert a word break opportunity after a colon
            str
              .replace(/(?<after>:)/giu, '$1<wbr>')
              // Before a single slash, tilde, period, comma, hyphen, underline, question mark, number sign, or percent symbol
              .replace(/(?<before>[/~.,\-_?#%])/giu, '<wbr>$1')
              // Before and after an equals sign or ampersand
              .replace(/(?<beforeAndAfter>[=&])/giu, '<wbr>$1<wbr>')
          // Reconnect the strings with word break opportunities after double slashes
        )
        .join('//<wbr>');
      el.innerHTML = formatted;
    } else {
      formatted = el.textContent;
    }
  });
  return formatted;
};
